import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { FeatureFlag, JobState, } from '@models';
import { isJson } from '@utils/string.utils';
import cloneDeep from 'lodash-es/cloneDeep';
var JobDetailsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobDetailsModalComponent, _super);
    function JobDetailsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._appState = _this._injector.get(AppStateFacade);
        _this._deserialize = function (args) {
            if (args == null ||
                args === 'null' ||
                !isJson(args)) {
                return args;
            }
            var parsed = JSON.parse(args);
            Object.keys(args)
                .forEach(function (key) {
                var parameterValue = parsed[key];
                try {
                    parsed[key] = JSON.parse(parameterValue);
                }
                catch (e) {
                    parsed[key] = parameterValue;
                }
            });
            return parsed;
        };
        return _this;
    }
    Object.defineProperty(JobDetailsModalComponent.prototype, "isJobSuspended", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.LongRunningJobs) &&
                this.context.data.state === JobState[JobState.Suspended];
        },
        enumerable: true,
        configurable: true
    });
    JobDetailsModalComponent.prototype.ngOnInit = function () {
        this.context.data = cloneDeep(this.context.data);
        this.context.data.inputArguments = this._deserialize(this.context.data.inputArguments);
        this.context.data.outputArguments = this._deserialize(this.context.data.outputArguments);
    };
    return JobDetailsModalComponent;
}(UiModalComponent));
export { JobDetailsModalComponent };
